import { Receipt, FileText, ImageSquare } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../lib/api";
import { downloadBlob, blobError } from "../lib/download";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "./ui/dropdown-menu";

export const downloadReceiptPdf = async (paymentId, filename, letterhead) => {
  try {
    const res = await api.get(`/order-payments/${paymentId}/receipt.pdf`, {
      params: { letterhead: letterhead ? 1 : 0 }, responseType: "blob" });
    downloadBlob(res.data, filename);
    toast.success(letterhead ? "Comprovante COM logotipo gerado — pronto para enviar ao cliente"
      : "Comprovante SEM logotipo gerado — pronto para enviar ao cliente");
  } catch (err) {
    toast.error(await blobError(err, "Erro ao gerar o comprovante"));
  }
};

export const ReceiptMenu = ({ paymentId, filename, testId, variant = "icon", label = "Baixar comprovante" }) => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      {variant === "icon" ? (
        <button type="button" data-testid={testId} title="Gerar comprovante de pagamento (PDF com ou sem logotipo)"
          onClick={(e) => e.stopPropagation()}
          className="text-zinc-500 hover:text-emerald-400 data-[state=open]:text-emerald-400 p-1 transition-colors">
          <Receipt size={14} />
        </button>
      ) : (
        <button type="button" data-testid={testId}
          className="flex-1 inline-flex items-center justify-center gap-1.5 border border-emerald-400/40 text-emerald-400 hover:bg-emerald-400/10 text-sm font-medium py-2.5 px-3 rounded transition-colors">
          <Receipt size={16} /> {label}
        </button>
      )}
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-60 bg-zinc-900 border-zinc-700 text-zinc-200 z-[200]">
      <DropdownMenuItem data-testid={`${testId}-with-logo`}
        onClick={(e) => { e.stopPropagation(); downloadReceiptPdf(paymentId, filename, true); }}
        className="gap-2 cursor-pointer focus:bg-zinc-800 focus:text-zinc-100">
        <ImageSquare size={15} className="text-indigo-400 shrink-0" /> Comprovante COM logotipo
      </DropdownMenuItem>
      <DropdownMenuItem data-testid={`${testId}-no-logo`}
        onClick={(e) => { e.stopPropagation(); downloadReceiptPdf(paymentId, filename, false); }}
        className="gap-2 cursor-pointer focus:bg-zinc-800 focus:text-zinc-100">
        <FileText size={15} className="text-zinc-400 shrink-0" /> Comprovante SEM logotipo
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
